import { ApiService } from "../../services/api.service";
import apiEndPoints from "../routeConfig";

const apiService = new ApiService();

export const getCountryMetaData = async () => {
  try {
    const res = await apiService.get(`${apiEndPoints.getCountryMetaData}`);
    return res;
  } catch (error) {
    return error;
  }
};

export const signUpMetaData = async () => {
  try {
    const res = await apiService.get(`${apiEndPoints.signUpMetaData}`);
    return res;
  } catch (error) {
    return error;
  }
};

export const countryMetaData = async () => {
  try {
    const res = await apiService.get(`${apiEndPoints.countryMetaData}`);
    return res;
  } catch (error) {
    return error;
  }
};

export const getAdministrativeLevelMetadata = async (level, countryId, parentId = null) => {
  try {
    let url = `${apiEndPoints.administrativeLevelMetadata}?level=${level}&countryId=${countryId}`;
    if (parentId) {
      url += `&parentId=${parentId}`;
    }
    const res = await apiService.get(url);
    return res;
  } catch (error) {
    return error;
  }
};

export const stateMetaData = async (countryId) => {
  try {
    const res = await apiService.get(`${apiEndPoints.stateMetaData}?countryId=${countryId}`);
    return res;
  } catch (error) {
    return error;
  }
};

export const districtMetaData = async (countryId, stateId) => {
  try {
    const res = await apiService.get(`${apiEndPoints.districtMetaData}?countryId=${countryId}&stateId=${stateId}`);
    return res;
  } catch (error) {
    return error;
  }
};

export const blockMetaData = async (countryId, stateId, districtId) => {
  try {
    const res = await apiService.get(
      `${apiEndPoints.blockMetaData}?countryId=${countryId}&stateId=${stateId}&districtId=${districtId}`
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const subscriptionMetaData = async (userTypeId, countryId) => {
  try {
    const res = await apiService.get(`${apiEndPoints.subscriptionMetaData}/${userTypeId}/${countryId}`);
    return res;
  } catch (error) {
    return error;
  }
};

export const paymentMethod = async () => {
  try {
    const res = await apiService.get(`${apiEndPoints.signUpMetaData}`);
    return res;
  } catch (error) {
    return error;
  }
};

export const signUpInitiativeMetaData = async (countryId) => {
  try {
    // If countryId is provided, fetch metadata for that country
    if (countryId) {
      const res = await apiService.get(`api/v1/eklink/user/signUp/countryBasedMetadata/${countryId}`);
      return res;
    }
    return { statusCode: 400, message: "Country ID is required" };
  } catch (error) {
    return error;
  }
};

export const postalCodeLookup = async (postalCode, countryId) => {
  try {
    const res = await apiService.get(
      `${apiEndPoints.postalCodeLookup}?postalCode=${postalCode}&countryId=${countryId}`
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const getInitiativesByCountry = async (countryId) => {
  try {
    const res = await apiService.get(`api/v1/eklink/user/signUp/initiatives/${countryId}`);
    return res;
  } catch (error) {
    return error;
  }
};

// Initiative approval chain: a DARE may pick only an Initiative its chosen area-based integrator's area joined.
export const getInitiativesOfferedByIntegrators = async (countryId, integratorIds) => {
  try {
    const ids = (integratorIds || []).map(String).join(',');
    const res = await apiService.get(
      `api/v1/eklink/user/signUp/initiatives/${countryId}/offered-by?integratorIds=${encodeURIComponent(ids)}`
    );
    return res;
  } catch (error) {
    return error;
  }
};

/**
 * Integrators a sign-up can pick in a country. With `personaType` (e.g. `SCORE_CUSTOMER`) the
 * backend returns only the integrators that persona may join; older backends ignore it.
 */
export const getIntegratorsByCountry = async (countryId, personaType) => {
  try {
    const query = personaType ? `?personaType=${encodeURIComponent(personaType)}` : '';
    const res = await apiService.get(`api/v1/eklink/user/signUp/integrators/${countryId}${query}`);
    return res;
  } catch (error) {
    return error;
  }
};

export const processPayment = async (paymentRequest) => {
  try {
    const res = await apiService.post(
      `api/v1/eklink/user/signUp/processPayment`,
      paymentRequest
    );
    console.log('processPayment: Success response:', res);
    return res;
  } catch (error) {
    // The axios interceptor transforms errors and includes all response fields
    // (statusCode, message, clientSecret, transactionId, etc.)
    console.log('processPayment: Error caught - returning error object:', error);
    return error;
  }
};

export const createPaymentIntent = async (amount, currency, paymentMethodType) => {
  try {
    const payload = {
      amount,
      currency,
      paymentMethodType,
    };
    const res = await apiService.post(
      `api/v1/eklink/user/signUp/createPaymentIntent`,
      payload
    );
    console.log('createPaymentIntent: Success response:', res);
    return res;
  } catch (error) {
    console.log('createPaymentIntent: Error caught:', error);
    return error;
  }
};

export const confirm3DSPayment = async (confirm3DSRequest) => {
  try {
    const res = await apiService.post(
      `api/v1/eklink/user/signUp/confirm3DS`,
      confirm3DSRequest
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const validatePromoCode = async (code) => {
  try {
    const res = await apiService.get(
      `${apiEndPoints.validatePromoCode}?code=${encodeURIComponent(code)}`
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const getFinancialSupportPlans = async (isActive = true) => {
  try {
    let url = apiEndPoints.financialSupportPlans;
    const params = new URLSearchParams();

    if (isActive !== null) {
      params.append('active', isActive);
    }

    if (params.toString()) {
      url += `?${params.toString()}`;
    }

    const res = await apiService.get(url);
    if (Array.isArray(res?.data)) {
      res.data = res.data.filter((plan) => plan?.active !== false);
    }
    return res;
  } catch (error) {
    return error;
  }
};
